export default "__VITE_ASSET__AqnOUHQv__"